$('.mask-phone').inputmask({
    mask: "(99) 9999-9999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true
});

$('.mask-cell').inputmask({
    mask: "(99) 99999-9999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true
});

$('.mask-date').inputmask({
    mask: "99/99/9999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true
});

$('.mask-cep').inputmask({
    mask: "99999-999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true,
    removeMaskOnSubmit: true
});

$('.mask-cpf').inputmask({
    mask: "999.999.999-99",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true,
    removeMaskOnSubmit: true
});

$('.mask-cnpj').inputmask({
    mask: "99.999.999/9999-99",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true
});

$('.mask-money').inputmask('decimal', {
    radixPoint:",",
    groupSeparator: ".",
    autoGroup: true,
    digits: 2,
    digitsOptional: false,
    placeholder: '0',
    rightAlign: false,
    numericInput: true,
    onBeforeMask: function (value, opts) {
        return value;
    }
});

$('.mask-card').inputmask({
    mask: "9999-9999-9999-9999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true,
    removeMaskOnSubmit: true,
});

$('.mask-validcard').inputmask({
    mask: "99/9999",
    showMaskOnFocus: true,
    showMaskOnHover: false,
    //autoUnmask: true,
    clearMaskOnLostFocus: true
});

// LOAD INPUT MASK
// Serve para iniciar em modais
function inputMaskLoad() {
    $('.mask-phone').inputmask({
        mask: "(99) 9999-9999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true
    });

    $('.mask-cell').inputmask({
        mask: "(99) 99999-9999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true
    });

    $('.mask-date').inputmask({
        mask: "99/99/9999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true
    });

    $('.mask-cep').inputmask({
        mask: "99999-999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true,
        removeMaskOnSubmit: true
    });

    $('.mask-cpf').inputmask({
        mask: "999.999.999-99",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true,
        removeMaskOnSubmit: true
    });

    $('.mask-cnpj').inputmask({
        mask: "99.999.999/9999-99",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true
    });

    $('.mask-money').inputmask('decimal', {
        radixPoint:",",
        groupSeparator: ".",
        autoGroup: true,
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        rightAlign: false,
        numericInput: true,
        onBeforeMask: function (value, opts) {
            return value;
        }
    });

    $('.mask-card').inputmask({
        mask: "9999-9999-9999-9999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true,
        removeMaskOnSubmit: true,
    });

    $('.mask-validcard').inputmask({
        mask: "99/9999",
        showMaskOnFocus: true,
        showMaskOnHover: false,
        //autoUnmask: true,
        clearMaskOnLostFocus: true
    });
}


